//Responsive breakpoints
export const QUERIES = {
	mobile: { maxWidth: 575 },

	tablet: {
		minWidth: 576,
		maxWidth: 1180,
	},

	desktop: { minWidth: 1181 },
};